// extracted by mini-css-extract-plugin
export default {"container":"GH","productarea":"HH","btn":"IH","promowrapper":"JH","upsellarea":"KH","subtitle":"LH","system":"MH","desc":"NH","cardswrap":"OH","cards":"PH","squareloadingcontainer":"QH","squareloading33":"RH"};
    if(module.hot) {
      // 1730991508613
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  